import { Component } from '@angular/core';
import { SmartWeatherComponent } from '../modules/smart-weather/smart-weather.component';

@Component({
  selector: 'ava-smart-weather-custom-element',
  template: ` <ava-smart-weather></ava-smart-weather> `,
  standalone: true,
  imports: [SmartWeatherComponent],
})
export class SmartWeatherCustomElementComponent {}
